import { Component, OnInit, HostListener, ChangeDetectionStrategy, signal, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { toSignal } from '@angular/core/rxjs-interop';
import { delay } from 'rxjs';
import { StorageService } from './service/storage.service';
import { LoaderService } from './service/loader.service';
import { AuthService } from './service/auth.service';
import { LanguageService } from './service/language.service';
import { CommonService } from './service/common.service';
import { UuidService } from './service/uuid.service';
import { HeaderComponent } from './components/header/header.component';
import { SideNavComponent } from './components/side-nav/side-nav.component';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: true,
    imports: [CommonModule, RouterOutlet, HeaderComponent, SideNavComponent],
})
export class AppComponent implements OnInit {
  private storage = inject(StorageService);
  private loading = inject(LoaderService);
  private auth = inject(AuthService);
  private commonService = inject(CommonService);

  isLoggedIn = signal(false);
  isLoading = toSignal(this.loading.loadingSub.pipe(delay(0)), { initialValue: false });
  sidebarOpen = toSignal(this.commonService.sidebarOpen$, { initialValue: true });
  isMobile = toSignal(this.commonService.isMobile$, { initialValue: false });

  constructor(private uuidService: UuidService) {
    this.storage.getItem('local', 'authData').subscribe((user: any) => {
      this.isLoggedIn.set(!!user);
    });
  }

  ngOnInit(): void {
    this.auth.generateSideNav();
    this.detectMobileScreen();
  }

  @HostListener('window:resize')
  onResize(): void {
    this.checkIsMobile();
  }

  private checkIsMobile(): void {
    const isMobile = window.innerWidth < 768;
    const wasMobile = this.commonService.isMobile$.value;
    this.commonService.isMobile$.next(isMobile);
    if (isMobile && !wasMobile) {
      this.commonService.sidebarOpen$.next(false);
    } else if (!isMobile && wasMobile) {
      this.commonService.sidebarOpen$.next(true);
    }
  }

  private detectMobileScreen(): void {
    this.checkIsMobile();
  }

  closeSidebar(): void {
    this.commonService.sidebarOpen$.next(false);
  }
}
